import React, {useState, useEffect} from "react";
import {instance} from "../../config/axios-cnf";
import SelectField from "../SelectField";


const TypeJobsField = (props) => {

    let [subject, setSubject] = useState([]);
    let [loading, setLoading] = useState(true);

    useEffect(() => apiGetSubject((data) => {
        let array = [];
        data.map(item => {
            array.push({
                label: item.name,
                value: item.id
            });
        })
        setSubject(array);
        setLoading(false)

    }, err => {
        //Toast.warn(translate("loading_error"))
    }), [])

    return (
        <SelectField {...props}
                     disabled={loading}
                     options={subject}
                     isMandatory={!!props.validate}
                     isMulti={props.isMulti}
        />
    )


}

export const apiGetSubject = (callback, error) => {
    instance.get('/api/v2/type-jobs')
        .then(response => callback(response.data))
}

export default TypeJobsField
